const APP_NAME     = 'Promoflex';
const DATA_API_KEY = '.data-api';

const $document    = $(document);
const $window      = $(window);
const $html        = $(document.documentElement).removeClass('has-no-js').addClass('has-js');
const $body        = $(document.body);
const $barba       = $('#js-barba-wrapper');

const isDebug      = !!$html.data('debug');

function lang() {
    return window.lang;
}

window.addEventListener('touchstart', function onFirstTouch() {
    $html.toggleClass('has-no-touch has-touch');
    window.removeEventListener('touchstart', onFirstTouch, false);
}, false);

export { APP_NAME, DATA_API_KEY, $document, $window, $html, $body, $barba, isDebug, lang };
